import api from './api';

// ── Auth ──────────────────────────────────────────────────────────────────
export const adminLogin       = (slug, data) => api.post(`/admin/${slug}/login`, data);
export const getAdminSettings = ()           => api.get('/admin/settings');
export const updateSettings   = (data)       => api.put('/admin/settings', data);
export const uploadAdminLogo  = (formData)   => api.put('/admin/settings', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const changeAdminPass  = (data)       => api.put('/admin/settings/password', data);

// ── Dashboard ─────────────────────────────────────────────────────────────
export const getDashboardStats  = ()       => api.get('/admin/dashboard');
export const getPlatformRevenue = (params) => api.get('/admin/revenue', { params });

// ── Doctors ───────────────────────────────────────────────────────────────
export const getAdminDoctors    = (params) => api.get('/admin/doctors', { params });
export const verifyDoctor       = (id)     => api.put(`/admin/doctors/${id}/verify`);
export const suspendDoctor      = (id, suspend) => api.put(`/admin/doctors/${id}/suspend`, { suspend });

// ── Patients ──────────────────────────────────────────────────────────────
export const getAdminPatients   = (params) => api.get('/admin/patients', { params });

// ── Appointments ──────────────────────────────────────────────────────────
export const getAllAppointments  = (params) => api.get('/admin/appointments', { params });

// ── Payments ──────────────────────────────────────────────────────────────
export const getPaymentQueue    = (params)  => api.get('/admin/payments', { params });
export const approvePayment     = (id)      => api.put(`/admin/payments/${id}/approve`);
export const bulkApprovePayments = (ids)    => api.put('/admin/payments/bulk-approve', { paymentIds: ids });

// ── Admin Forgot Password ─────────────────────────────────────────────────
export const adminForgotSendOTP = (data)  => api.post('/admin/forgot-password/send-otp', data);
export const adminForgotReset   = (data)  => api.post('/admin/forgot-password/reset', data);
export const setAdminRecoveryPhone = (phone) => api.put('/admin/settings/recovery-phone', { phone });

export const getPublicSettings = () => api.get('/admin/public-settings');

// ── Admin Staff Management ────────────────────────────────────────────────
export const getAdminStaff         = ()           => api.get('/admin-staff');
export const createAdminStaff      = (data)       => api.post('/admin-staff', data);
export const updateAdminStaff      = (id, data)   => api.put(`/admin-staff/${id}`, data);
export const deleteAdminStaff      = (id)         => api.delete(`/admin-staff/${id}`);
export const resetAdminStaffPass   = (id, data)   => api.put(`/admin-staff/${id}/password`, data);
export const adminStaffLogin       = (data)       => api.post('/admin-staff/login', data);
